import * as React from "react";
import NavMenu from "./NavMenu";
import SiteFooter from "./SiteFooter";

const Layout = (props) => (
    <React.Fragment>
        <NavMenu/>
        {props.children}
        <SiteFooter />
    </React.Fragment>
);

export default Layout;